module.exports = __webpack_public_path__ + "static/img/1530694543457212618.94ac8c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture/1530694543457212618.jpg
// module id = vl6b
// module chunks = 0